import { CommonOptionVM } from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"

export class UrlOptionsVM extends CommonOptionVM {
  [keyof: string]: any

  constructor(data: Partial<UrlOptionsVM> = {}) {
    super(data)
    Object.keys(data).forEach(key => {
      this[key] = data[key]
    })
  }

  validateData() {
    const errors: any[] = []
    // if (true) {
    //   errors.push({key: 'key_name', error_message: 'error_message'})
    // }
    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default UrlOptionsVM